module.exports = __webpack_public_path__ + "img/JabarJamal.e096308f.jpg";